import { useCallback } from 'react';

import { User } from '@/types/userList';

export const useShowUserForm = (
  isPreview: boolean,
  selectedUserId: number | null,
  users: User[] | null,
) => {
  const showUserForm = useCallback<(index: number) => boolean>(
    (index) => {
      if (isPreview || !users) {
        return false;
      }

      const user = users[index];

      if (!user) {
        return false;
      }

      return user.id === selectedUserId;
    },
    [isPreview, selectedUserId, users],
  );

  return { showUserForm };
};
